import { LabelsActionTypes, ImageData, LabelName, TagName, AnnotationData } from "./types";
import { Action } from "../Actions";
import { LabelType } from "../../data/enums/LabelType";
import { LabelsSelector } from "../selectors/LabelsSelector";

export function updateActiveImageIndex(
  activeImageIndex: number
): LabelsActionTypes {
  return {
    type: Action.UPDATE_ACTIVE_IMAGE_INDEX,
    payload: {
      activeImageIndex,
    },
  };
}

export function updateActiveLabelNameId(
  activeLabelNameId: string | null
): LabelsActionTypes {
  return {
    type: Action.UPDATE_ACTIVE_LABEL_NAME_ID,
    payload: {
      activeLabelNameId,
    },
  };
}

export function updateActiveLabelId(activeLabelId: string | null): LabelsActionTypes {
  return {
    type: Action.UPDATE_ACTIVE_LABEL_ID,
    payload: {
      activeLabelId,
    },
  };
}

export function updateHighlightedLabelId(
  highlightedLabelId: string | null
): LabelsActionTypes {
  return {
    type: Action.UPDATE_HIGHLIGHTED_LABEL_ID,
    payload: {
      highlightedLabelId,
    },
  };
}

export function updateActiveLabelType(
  activeLabelType: LabelType
): LabelsActionTypes {
  return {
    type: Action.UPDATE_ACTIVE_LABEL_TYPE,
    payload: {
      activeLabelType,
    },
  };
}
export function updateImageData(imageData: ImageData[]): LabelsActionTypes {
  return {
    type: Action.UPDATE_IMAGES_DATA,
    payload: {
      imageData,
    },
  };
}

export const updateAnnotationCount = (annotationCounts: number[]) => {
  return {
    type: Action.UPDATE_ANNOTATION_COUNT,
    payload: {
        annotationCounts,
    },
  };
};

export const updateSaveStatus = (UpdateSaveStatus: boolean) => {
  return {
    type: Action.UPDATE_SAVESTATUS,
    payload: {
      UpdateSaveStatus,
    },
  };
};



export const updateAudioUrl = (audioUrl: string): LabelsActionTypes => {
  return {
    type: Action.UPDATE_AUDIO_URL,
    payload: {
      audioUrl,
    },
  };
};




// export function updateImageDataById(
//   id: string,
//   newImageData: ImageData
// ): LabelsActionTypes {
//   const undoRedo: [] = JSON.parse(localStorage.getItem(`undoRedo_${newImageData.image_id}`)) ?? [];
//   const a = [newImageData, ...undoR  edo.slice(JSON.parse(localStorage.getItem(`undoindex_${newImageData.image_id}`)), 19)]
//   localStorage.setItem(`undoRedo_${newImageData.image_id}`, JSON.stringify(a))
//   localStorage.setItem(`undoindex_${newImageData.image_id}`, JSON.stringify(0))
//   return {
//     type: Action.UPDATE_IMAGE_DATA_BY_ID,
//     payload: {
//       id,
//       newImageData,
//     },
//   };
// }

// export function updateImageDataById(
//   id: string,
//   newImageData: ImageData
// ): LabelsActionTypes {
//   const undoRedo: ImageData[] = JSON.parse(localStorage.getItem(`undoRedo_${newImageData.image_id}`)) ?? [];
//   const latestEntry = undoRedo.length > 0 ? undoRedo[0] : null;
//   if (latestEntry && JSON.stringify(latestEntry) === JSON.stringify(newImageData)) {
//     // console.log('Entry is the same as the latest one, not storing it.');
//   } else {
//     const updatedUndoRedo = [newImageData, ...undoRedo.slice(JSON.parse(localStorage.getItem(`undoindex_${newImageData.image_id}`)), 19)];
//     localStorage.setItem(`undoRedo_${newImageData.image_id}`, JSON.stringify(updatedUndoRedo));
//     localStorage.setItem(`undoindex_${newImageData.image_id}`, JSON.stringify(0));
//     // console.log('Entry is different from the latest one, so storing it.');
//   }

//   return {
//     type: Action.UPDATE_IMAGE_DATA_BY_ID,
//     payload: {
//       id,
//       newImageData,
//     },
//   };
// }



export function updateImageDataById(
  id: string,
  newImageData: ImageData
): LabelsActionTypes {
  return {
    type: Action.UPDATE_IMAGE_DATA_BY_ID,
    payload: {
      id,
      newImageData,
      trackUndo: true,
    },
  };
}

/** Replace several frames in one Redux update, recording undo for the open frame. */
export function updateImageDataBatch(
  images: ImageData[],
  undoImageId: string | null
): LabelsActionTypes {
  return {
    type: Action.UPDATE_IMAGE_DATA_BATCH,
    payload: { images, undoImageId },
  };
}


export function updateImageDataByIdwithoutundo(
  id: string,
  newImageData: ImageData
): LabelsActionTypes {
  return {
    type: Action.UPDATE_IMAGE_DATA_BY_ID,
    payload: {
      id,
      newImageData,
      trackUndo: false,
    },
  };
}

export function setImageUndoIndex(
  imageId: string,
  undoIndex: number
): LabelsActionTypes {
  return {
    type: Action.SET_IMAGE_UNDO_INDEX,
    payload: {
      imageId,
      undoIndex,
    },
  };
}

export function undoRedo(
  id: string,
  newImageData: ImageData
): LabelsActionTypes {
  // window.alert("yes")
  return {
    type: Action.UPDATE_IMAGE_DATA_BY_ID,
    payload: {
      id,
      newImageData,
    },

  };
}
export function addImageData(imageData: ImageData[]): LabelsActionTypes {
  return {
    type: Action.ADD_IMAGES_DATA,
    payload: {
      imageData,
    },
  };
}



export function updateLabelNames(labels: LabelName[]): LabelsActionTypes {
  return {
    type: Action.UPDATE_LABEL_NAMES,
    payload: {
      labels,
    },
  };
}
export function updateTagNames(tags: TagName[]): LabelsActionTypes {
  return {
    type: Action.UPDATE_TAG_NAMES,
    payload: {
      tags,
    },
  };
}

export function updateFirstLabelCreatedFlag(
  firstLabelCreatedFlag: boolean
): LabelsActionTypes {
  return {
    type: Action.UPDATE_FIRST_LABEL_CREATED_FLAG,
    payload: {
      firstLabelCreatedFlag,
    },
  };
}

export function updateAnnotations(annotations: { [key: string]: AnnotationData }): LabelsActionTypes {
  return {
    type: Action.UPDATE_ANNOTATIONS,
    payload: {
      annotations,
    },
  };
}

export function updateVideoTrackingEnabled(
  videoTrackingEnabled: boolean
): LabelsActionTypes {
  return {
    type: Action.UPDATE_VIDEO_TRACKING_ENABLED,
    payload: {
      videoTrackingEnabled,
    },
  };
}

export function updatePendingTrackId(
  pendingTrackId: string | null
): LabelsActionTypes {
  return {
    type: Action.UPDATE_PENDING_TRACK_ID,
    payload: {
      pendingTrackId,
    },
  };
}
